import { Breakpoints, ImageWithOptionalCTA } from '@nextgen-web-framework/all';
import type { ImageWithOptionalCTAProptypes } from '@nextgen-web-framework/all';
import { FC } from 'react';
import type { ImageWithOptionalCTAPropType, ImagePerViewportPropType, ImagePropType } from './types/propsTypes';
import styles from './ImageWithOptionalCTA.module.scss';

const ImageWithOptionalCTAContainer: FC<ImageWithOptionalCTAPropType> = (props: ImageWithOptionalCTAPropType) => {
  const { bgColor, button, link, config, imgList, rounded } = props;
  const initialPayload: ImagePerViewportPropType = {
    src: '',
    alt: '',
    borderRadius: 0,
    width: 0,
  };
  const imgPerViewport: Record<Breakpoints, ImagePerViewportPropType> = {
    [Breakpoints.XS]: initialPayload,
    [Breakpoints.SM]: initialPayload,
    [Breakpoints.MD]: initialPayload,
    [Breakpoints.LG]: initialPayload,
    [Breakpoints.XL]: initialPayload,
  };
  imgList.forEach(({ alt, image_file, viewport, width }: ImagePropType) => {
    const payload = {
      alt: alt,
      src: image_file.url as string,
      borderRadius: config.rounded ? Number(styles.roundedImageRadius) : 0,
      width: width,
    };
    viewport.forEach((breakpoint: string) => (imgPerViewport[breakpoint as Breakpoints] = payload));
  });
  const customProp: ImageWithOptionalCTAProptypes = {
    className: '',
    containerBorderRadius: rounded ? Number(styles.roundedContainerRadius) : 0,
    bgColor,
    imgPerViewport,
    button: button?.title ? button : undefined,
  };
  if (link?.url) {
    customProp.ctaConfig = {
      href: link.url,
      target: link.target ?? '_blank',
    };
  }
  return (
    <div className={styles['image-with-optional-cta-container']}>
      <ImageWithOptionalCTA {...customProp} />
    </div>
  );
};

export default ImageWithOptionalCTAContainer;
